var map = {
	"./bucha2023/bucha-01.webp": 6687,
	"./bucha2023/bucha-02.webp": 9534,
	"./bucha2023/bucha-03.webp": 425,
	"./bucha2023/bucha-04.webp": 1280,
	"./bucha2023/bucha-05.webp": 5123,
	"./bucha2023/bucha-06.webp": 1346,
	"./bucha2023/bucha-07.webp": 4365,
	"./bucha2023/bucha-08.webp": 8548,
	"./bucha2023/bucha-09.webp": 2583,
	"./bucha2023/bucha-10.webp": 7593,
	"./bucha2023/bucha-11.webp": 4846,
	"./bucha2023/bucha-12.webp": 4143,
	"./bucha2023/bucha-13.webp": 6924,
	"./bucha2023/bucha-14.webp": 5453,
	"./bucha2023/bucha-15.webp": 7762,
	"./poland/poland-photo1.webp": 8422,
	"./poland/poland-photo10.webp": 7546,
	"./poland/poland-photo2.webp": 4023,
	"./poland/poland-photo3.webp": 5812,
	"./poland/poland-photo4.webp": 8357,
	"./poland/poland-photo5.webp": 4877,
	"./poland/poland-photo6.webp": 6779,
	"./poland/poland-photo7.webp": 3960,
	"./poland/poland-photo8.webp": 1513,
	"./poland/poland-photo9.webp": 1790,
	"./slovakia/slovakia-photo1.webp": 8954,
	"./slovakia/slovakia-photo10.webp": 8982,
	"./slovakia/slovakia-photo2.webp": 8475,
	"./slovakia/slovakia-photo3.webp": 9304,
	"./slovakia/slovakia-photo4.webp": 4849,
	"./slovakia/slovakia-photo5.webp": 118,
	"./slovakia/slovakia-photo6.webp": 9367,
	"./slovakia/slovakia-photo7.webp": 7508,
	"./slovakia/slovakia-photo8.webp": 3565,
	"./slovakia/slovakia-photo9.webp": 7154,
	"./svichado/svichado-01.webp": 6796,
	"./svichado/svichado-03.webp": 1182,
	"./svichado/svichado-04.webp": 419,
	"./svichado/svichado-05.webp": 2928,
	"./turkey/Turkey_1.webp": 2978,
	"./turkey/Turkey_2.webp": 3699,
	"./turkey/Turkey_3.webp": 1488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1077;